// Importiere Firebase
import { initializeApp } from "firebase/app";
import {
  browserLocalPersistence,
  getAuth,
  indexedDBLocalPersistence,
  initializeAuth,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { Capacitor } from "@capacitor/core";
// Deine Firebase-Konfiguration
const firebaseConfig = {
  apiKey: "AIzaSyADImUshj1ZvC7a56KiUs57eCU-J2v3HV8",
  authDomain: "vaultquest-7741a.firebaseapp.com",
  projectId: "vaultquest-7741a",
  storageBucket: "vaultquest-7741a.appspot.com",
  messagingSenderId: "1076248800509",
  appId: "1:1076248800509:web:2faf67caf6c45fe732e294",
  measurementId: "G-1T2RS0GS7R"
};

// Firebase initialisieren
export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

// Dienste exportieren, damit andere Dateien sie nutzen können
export const auth = Capacitor.isNativePlatform()
  ? initializeAuth(app, {
      persistence: [indexedDBLocalPersistence, browserLocalPersistence],
    })
  : getAuth(app);


export const functions = getFunctions(app);
